export default __webpack_public_path__ + "static/media/befit.c1297bc7.jpg";